import {
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    USER_LOADED_SUCCESS,
    USER_LOADED_FAIL,
    AUTHENTICATED_SUCCESS,
    AUTHENTICATED_FAIL,
    LOGOUT,
} from './types';
import axios from 'axios';

export const checkAuthenticated = () => async dispatch => {
    if (localStorage.getItem("access")){
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };
        const body = JSON.stringify({'token': localStorage.getItem("access")});
        try {
            const res = await axios.post(`${process.env.REACT_APP_AUTH_URL}/auth/jwt/verify/`, body, config);
            if (res.data.code !== "token_not_valid") {
                dispatch({
                    type: AUTHENTICATED_SUCCESS
                });
            } else {
                dispatch({
                    type: AUTHENTICATED_FAIL
                });
            }
        } catch (err) {
            dispatch({
                type: AUTHENTICATED_FAIL
            });
        }
    } else {
        dispatch({
            type: AUTHENTICATED_FAIL
        });
    }
};


export const load_user = () => async dispatch => {
    if (localStorage.getItem("access")){
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem("access")}`,
                'Accept': 'application/json'
            }
        };

        try {
            const res = await axios.get(`${process.env.REACT_APP_AUTH_URL}/auth/users/me/`, config);
            dispatch({
                type: USER_LOADED_SUCCESS,
                payload: res.data
            });
        } catch (err) {
            dispatch({
                type: USER_LOADED_FAIL
            });
        }
    } else {
        dispatch({
            type: USER_LOADED_FAIL
        });
    }
};

export const googleLogin = (payload) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    // Accept a GIS ID token string, or { code } / { credential } from the button.
    const bodyPayload =
        typeof payload === 'string' ? { credential: payload } : payload || {};
    const body = JSON.stringify(bodyPayload);
    try {
        const res = await axios.post(`${process.env.REACT_APP_AUTH_URL}/auth/google/`, body, config);
        dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data
        });
        dispatch(load_user());
        return 'success';
    } catch (err) {
        dispatch({
            type: LOGIN_FAIL
        });
        return err?.response?.data?.detail || 'error';
    }
};

export const logout = () => dispatch => {
    dispatch({
        type: LOGOUT
    });
}
